import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterContainerSectionControl from './VeltCommentsSidebarV2FilterContainerSectionControl/VeltCommentsSidebarV2FilterContainerSectionControl';
import VeltCommentsSidebarV2FilterContainerSectionOptionList from './VeltCommentsSidebarV2FilterContainerSectionOptionList/VeltCommentsSidebarV2FilterContainerSectionOptionList';
var VeltCommentsSidebarV2FilterContainerSectionField = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-container-v2-section-field-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterContainerSectionField.Control = VeltCommentsSidebarV2FilterContainerSectionControl;
VeltCommentsSidebarV2FilterContainerSectionField.OptionList = VeltCommentsSidebarV2FilterContainerSectionOptionList;
export default VeltCommentsSidebarV2FilterContainerSectionField;
